// extracted by mini-css-extract-plugin
export var addToCartButton = "_pu-b";
export var arrowButtonContainer = "_pu-9";
export var arrowButtonIcon = "_pu-a";
export var carouselArrowButton = "_pu-6";
export var carouselElementContainer = "_pu-1";
export var galleryThumbnail = "_pu-d";
export var galleryThumbnailImage = "_pu-e";
export var left = "_pu-7";
export var productDisplayCarouselContainer = "_pu-0";
export var productTileContainer = "_pu-2";
export var productTileImage = "_pu-4";
export var productTileImageContainer = "_pu-3";
export var productTileTitle = "_pu-5";
export var right = "_pu-8";
export var sliderOverflow = "_pu-c";